export const optimizeImageToWebP = async (
  file,
  options = {}
) => {
  // Only process images
  if (!file || !file.type.startsWith("image/")) {
    return file
  }

  const {
    quality = 0.75,
    maxWidth = 1600,
    maxHeight = 1600,
  } = options

  const bitmap = await createImageBitmap(file)

  let width = bitmap.width
  let height = bitmap.height

  // Never upscale
  const scale = Math.min(
    maxWidth / width,
    maxHeight / height,
    1
  )

  width = Math.round(width * scale)
  height = Math.round(height * scale)

  const canvas = document.createElement("canvas")
  canvas.width = width
  canvas.height = height

  const ctx = canvas.getContext("2d")
  if (!ctx) {
    bitmap.close()
    throw new Error("Canvas not supported")
  }

  ctx.drawImage(bitmap, 0, 0, width, height)
  bitmap.close()

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("WebP conversion failed"))),
      "image/webp",
      quality
    )
  })

  return new File(
    [blob],
    file.name.replace(/\.[^/.]+$/, ".webp"),
    { type: "image/webp" }
  )
}
